import PropTypes from 'prop-types';

import BrTooltip from '@components/BrTooltip';

export default function TooltipColumn({ col, cell }) {
  const { location, isDark } = col.columnConfig || {};
  return !cell.tooltip ? (
    cell.value
  ) : (
    <BrTooltip location={location} isDark={isDark}>
      {cell.value}
      <BrTooltip.Tooltip>
        {typeof cell.tooltip === 'string' ? cell.tooltip : cell.tooltip.map((msg) => <p>{msg}</p>).join('')}
      </BrTooltip.Tooltip>
    </BrTooltip>
  );
}

TooltipColumn.propTypes = {
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      location: PropTypes.string,
      isDark: PropTypes.bool,
    }),
  }).isRequired, // column config
  cell: PropTypes.shape({
    value: PropTypes.any,
    tooltip: PropTypes.oneOf([PropTypes.string, PropTypes.arrayOf(PropTypes.any)]),
  }).isRequired,
};
